<template>
  <div>
    <v-btn :text="text" :variant="variant" :color="color" :prepend-icon="icon" :loading="loading" @click="change"
      block />
  </div>
</template>

<script>
import accountService from '@/services/Account.service';

export default {
  name: 'ChangePasswordButton',
  data() {
    return {
      text: 'Change Password',
      variant: 'text',
      color: '',
      icon: 'mdi-form-textbox-password',
      loading: false,
    }
  },
  methods: {
    async change() {
      this.loading = true;

      const accessToken = await this.$auth0.getAccessTokenSilently();

      const { data, error } = await accountService.changePassword(accessToken);

      if (data) {

        if (data.url) {
          window.location.href = data.url; //Redirect to change password ticket URL
        }
      }

      if (error) {
        this.newAlert(error.alert.type, error.alert.title, error.alert.text, error.status);

        this.loading = false;

        console.error(error);
      }
    },
  },
};
</script>